import React, { useState, useEffect } from "react";
import { Cloudinary } from "@cloudinary/url-gen";
import "./ImpactHero.css";

// Initialize Cloudinary instance
const cld = new Cloudinary({
  cloud: {
    cloudName: 'di0r4dirk'
  }
});

const Hero = () => {
  const [isHeroLoaded, setIsHeroLoaded] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1000
  );

  // Track window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get optimized hero image URL from Cloudinary
  const getHeroImageUrl = () => {
    const publicId = 'getting-some-street-food_gunyg7';
    
    let targetWidth = 1000; 
    
    if (windowWidth <= 768) {
      targetWidth = 768; // Mobile
    } else if (windowWidth <= 1000) {
      targetWidth = 1000; // Default
    }
    
    const heroImg = cld.image(publicId)
      .format('auto')
      .quality('auto:good')
      .resize(`w_${targetWidth}`);
    
    return heroImg.toURL();
  };

  // Preload the hero image
  useEffect(() => {
    const preloadHeroImage = () => {
      const img = new Image();
      img.src = getHeroImageUrl();
      img.onload = () => setIsHeroLoaded(true);
      img.onerror = () => {
        console.error('Failed to load hero image');
        setIsHeroLoaded(true);
      };
    };

    preloadHeroImage();
  }, [windowWidth]);

  return (
    <div 
      className={`impact-hero-section ${isHeroLoaded ? 'loaded' : 'loading'}`}
      style={{
        backgroundImage: `url(${getHeroImageUrl()})`,
        backgroundPosition: 'bottom',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="overlay">
        <h1 className="hero-title">
          About Our Films
        </h1>
      </div>
    </div>
  );
};

export default Hero;